import { FC, ReactNode } from 'react';
import { connect } from 'react-redux';
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';
import { SeoLink } from 'dibs-elements/exports/SeoLink';

type ReduxStoreType = {
    header: {
        isNavigationRefreshVariant: boolean;
    };
};

type Props = {
    trackingLabel: string;
    serverRenderedChildren: ReactNode;
    href: string;
    isLinkable: boolean;
    target?: '_blank';
    dataTn: string;
    linkContent: ReactNode;
    isNavigationRefreshVariant: boolean;
};

const FooterSeoLinkWrapper: FC<Props> = ({
    trackingLabel,
    href,
    isLinkable,
    target,
    dataTn,
    linkContent,
    isNavigationRefreshVariant,
}) => (
    <SeoLink
        onClick={event => {
            trackFooterNavigationClick({ label: trackingLabel }, event);
        }}
        linkData={{
            path: href,
            isLinkable,
        }}
        target={target}
        dataTn={dataTn}
        buyerLinkType={isNavigationRefreshVariant ? 'standardLinkNoUnderline' : 'contrastLinkLight'}
    >
        {linkContent}
    </SeoLink>
);

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isNavigationRefreshVariant: boolean;
} => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default connect(mapStateToProps)(FooterSeoLinkWrapper);
